const getMenuContent = () => {
    const userData = JSON.parse(localStorage.getItem('authUser'));
    const userType = userData?.userType;

    // Common menu items for all users
    const commonMenuItems = [
        {
            title: 'JOB CARD',
            to: 'JobCardForm',
        },
        {
            title: 'CLOSING REPORT',
            to: 'ClosingReport',
        }
    ];

    // Admin menu items (F_UserType = 1) - structured into sections
    const adminMenuItems = [
        {
            title: 'FIRM MASTER',
            to: 'FirmMaster',
        },
        {
            title: 'DESIGNATION MASTER',
            to: 'DesignationMaster',
        },
        {
            title: 'DEPARTMENT MASTER',
            to: 'DepartmentMaster',
        },
        {
            title: 'EMPLOYEE MASTER',
            to: 'EmployeeMaster',
        },
        {
            title: 'WORKER CATEGORY',
            to: 'WorkerCategory',
        },
        {
            title: 'PAYROLL PARAMETER',
            to: 'PayrollParameter',
        },
        {
            title: 'LEAVE MASTER',
            to: 'LeaveMaster',
        },
        {
            title: 'ALLOWANCE MASTER',
            to: 'AllowanceMaster',
        },
        {
            title: 'DEDUCTION MASTER',
            to: 'DeductionMaster',
        },
    ];

    // Admin reporting items
    const adminReportingItems = [];

    // Supervisor menu items (F_UserType = 2)
    const supervisorMenuItems = [
        {
            title: 'MACHINE COMPONENT REPORT',
            to: 'MachineComponentMapReport',
        },
        {
            title: 'CREATE AL SLIP',
            to: 'AddALSlip',
        },
        {
            title: 'AL SLIP',
            to: 'ALSlip',
        },
        {
            title: 'WOOD ISSUE',
            to: 'AddWoodIssue',
        },
        {
            title: 'ADD OTHER SLIP',
            to: 'AddOtherSlip',
        },
        {
            title: 'SUPERVISOR ENTRY',
            to: 'SupervisorEntry',
        },
        {
            title: 'MANUAL REPORT ENTRY',
            to: 'ManualReportEntry',
        }
    ];

    // Operator menu items (F_UserType = 3)
    const operatorMenuItems = [
        {
            title: 'MACHINE COMPONENT REPORT',
            to: 'MachineComponentMapReport',
        }
    ];

    // Return menu items based on user type
    switch (userType) {
        case 1: // Admin
            return { adminMenuItems, adminReportingItems };
        case 2: // Supervisor
            return [...supervisorMenuItems, ...commonMenuItems];
        case 3: // Operator
            return [...operatorMenuItems, ...commonMenuItems];
        default:
            return commonMenuItems;
    }
};

export const getMenuList = () => {
    const userData = JSON.parse(localStorage.getItem('authUser'));
    const userType = userData?.userType;
    const menuData = getMenuContent();

    const baseMenu = [
        {
            title: 'DASHBOARD',
            to: 'dashboard',
        }
    ];

    // Transaction menu items
    const transactionMenuItems = [
        {
            title: 'PAYROLL',
            to: 'Payroll',
        },
        {
            title: 'MULTI PAYROLL ENTRY',
            to: 'MultiPayrollEntry',
        },
    ];

    if (userType === 1) { // Admin
        return [
            ...baseMenu,
            {
                title: 'MASTERS',
                classsChange: 'mm-collapse',
                customClass: 'section-header-menu',
                content: menuData.adminMenuItems
            },
            {
                title: 'TRANSACTION',
                classsChange: 'mm-collapse',
                customClass: 'section-header-menu',
                content: transactionMenuItems
            },
        ];
    } else {
        return [
            ...baseMenu,
            {
                title: 'MENU ITEMS',
                classsChange: 'mm-collapse',
                content: menuData
            }
        ];
    }
};

export const MenuList = getMenuList;